import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { sessionExpiryInterceptor } from './core/interceptors/session-expiry.interceptor';
import { APP_CONFIG, AppConfig } from './core/tokens/app-config.token';
import { environment } from '../environments/environment';

const appConfigValue: AppConfig = {
  apiBaseUrl: environment.apiBaseUrl,
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, sessionExpiryInterceptor])),
    provideAnimations(),
    provideNativeDateAdapter(),
    provideCharts(withDefaultRegisterables()),
    { provide: APP_CONFIG, useValue: appConfigValue },
  ],
};
